import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const WavesIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame 1000005810">
        <path
          id="Vector"
          d="M10.8569 3.38464L7.46868 6.77286L4.08047 3.38464L0.692261 6.77286L4.08047 10.1611L7.46868 6.77286L10.8569 10.1611L7.46868 13.5493L10.8569 16.9375L14.2451 13.5493L10.8569 10.1611L14.2451 6.77286L10.8569 3.38464ZM14.268 6.77222L17.6327 3.40432L21.0006 6.77222L17.6327 10.1401L14.268 6.77222Z"
          fill={fillColor || '#9D9DA6'}
        />
      </g>
    </svg>
  );
};

export { WavesIcon };
